import { Box, Button, CircularProgress, Modal } from "@mui/material";
import { sxButton, sxModal, sxOutlinedButton } from "../../SaudeOnline/AgendarConsulta/sxProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './styles.css';
import { useState } from "react";
import { revalidarGuia } from "../../../services/MinhasGuiasService";
import CheckIcon from "./CheckIcon";
import ErrorIcon from "./ErrorIcon";
import { RevalidationGuideModalProps } from "../../../interfaces/props/GuiasEAutorizacoes/RevalidationGuideModalProps";
import { useNavigate } from "react-router-dom";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

function RevalidationGuideModal(props: RevalidationGuideModalProps) {

    const accessibility = useAccessibility();

    const [loading, setLoading] = useState<boolean>(false);
    const [sucess, setSucess] = useState<boolean>(false);
    const [failure, setFailure] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('Sua guia foi revalidada com sucesso!');

    const navigate = useNavigate();

    const handleConfirmation = async () => {
        setLoading(true)
        const result = await revalidarGuia(props.idSolic, 'S');
        if (result !== null) {
            setMessage(result.data ? result.data : 'Sua guia foi revalidada com sucesso!')
            setLoading(false);
            setSucess(true);
        }
        else {
            setLoading(false);
            setFailure(true);
        }
    }

    const handleClose = () => {
        setLoading(false);
        setSucess(false);
        setFailure(false)
        if (sucess) {
            setSucess(false);
            props.handleClose(true);
        }
        else {
            setSucess(false);
            props.handleClose(false);
        }

        if (!loading && sucess && !failure) {
            navigate('/guiasEautorizacoes/minhasGuiasEmitidas')
        }
    }

    return (
        <div>
            <Modal
                open={props.open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                aria-live="polite"
            >
                <Box sx={sxModal} style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
                    {!loading &&
                        <div className="activation-guide-card-feedback-modal-header">
                            <button className='activation-guide-card-modal-header-close' onClick={handleClose} aria-label="fechar">
                                <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faTimes} />
                            </button>
                        </div>
                    }
                    {loading &&
                        <div className="loading-holder">
                            <CircularProgress />
                        </div>
                    }
                    {!loading && sucess && !failure &&
                        <div className="activation-guide-card-modal-feedback">
                            <div className="icon-holder">
                                <CheckIcon />
                            </div>
                            <h1 className="activation-guide-card-feedback-modal-title"
                                style={accessibility.textStyleAccessibility}>
                                Confirmado
                            </h1>
                            <p className="activation-guide-card-feedback-modal-message"
                                style={accessibility.textStyleAccessibility}>
                                {message}
                            </p>
                        </div>
                    }
                    {!loading && !sucess && failure &&
                        <div className="activation-guide-card-modal-feedback">
                            <div className="icon-holder">
                                <ErrorIcon />
                            </div>
                            <h1 className="activation-guide-card-feedback-modal-title"
                                style={accessibility.textStyleAccessibility}>
                                Erro
                            </h1>
                            <p className="activation-guide-card-feedback-modal-message"
                                style={accessibility.textStyleAccessibility}>
                                Houve um erro ao revalidar a guia!
                            </p>
                        </div>
                    }
                    {!loading && !sucess && !failure &&
                        <div>
                            <h1 className="activation-guide-card-feedback-modal-title"
                                style={accessibility.textStyleAccessibility}>
                                Revalidação de guia
                            </h1>
                            <p className="activation-guide-card-feedback-modal-message"
                                style={accessibility.textStyleAccessibility}>
                                Deseja revalidar a guia {props.idSolic || ''}?
                            </p>
                            <div className="activation-guide-modal-button-holder">
                                <div className="activation-guide-card-button">
                                    <Button
                                        variant="outlined"
                                        onClick={handleClose}
                                        style={accessibility.buttonStyleAccessibility}
                                        sx={sxOutlinedButton}
                                        disabled={false}
                                        fullWidth>
                                        <span style={{...accessibility.textStyleAccessibility, color: '#00995D'}} >
                                            CANCELAR
                                        </span>
                                    </Button>
                                </div>
                                <div className="activation-guide-card-button">
                                    <Button
                                        variant="contained"
                                        onClick={handleConfirmation}
                                        sx={sxButton}
                                        style={accessibility.buttonStyleAccessibility}
                                        disabled={false}
                                        fullWidth>
                                        <span style={accessibility.textStyleAccessibility} >
                                            CONFIRMAR
                                        </span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    }
                </Box>
            </Modal>
        </div>
    )
}

export default RevalidationGuideModal;
